import React from 'react'
import { ImageList } from '@material-ui/core'
import MediaItemImage from 'src/components/media/item/image'
import { MediaItemType } from 'src/model/media-directory'
import style from '../style'
import withStyles from '@material-ui/core/styles/withStyles'
const MediaGrid = ({ items, onSelect, dispatch, classes }) => {
  if (!items || items.length === 0) {
    return (
      <div className={classes.entityNull}>
        <img src="/assets/editor-file/media/empty-media.svg" alt="" />
      </div>
    )
  }

  return (
    <ImageList className={classes.imageList} cols={4}>
      {items.map(mediaItem => (
        <MediaItemImage
          {...mediaItem}
          key={mediaItem.id}
          onSelect={onSelect}
          dispatch={dispatch}
          type={MediaItemType.IMAGE}
        />
      ))}
    </ImageList>
  )
}

export default withStyles(style)(MediaGrid)
